<script setup lang="ts">
import { RouterView } from 'vue-router';
</script>

<template>
  <RouterView />
</template>

<style>
:root {
  --primary: #1F4E79;
  --accent: #2E75B6;
  --bg: #F5F7FA;
  --text: #1A1A1A;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, 'Segoe UI', Arial, sans-serif;
  background: var(--bg);
  color: var(--text);
}
</style>
